import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

import { CardSliderCardContent, IconPack } from '../../models/app-data-model';
import ShLink from '../sh-link/sh-link';
import './card-slider-card.scss';
import { corewellCardGridOverrideClasses } from '../../../constants/constants';

export type CardSliderCardProps = {
  content: CardSliderCardContent;
  corewellStyleOverrides?: boolean;
  iconPack: IconPack[];
};


const CardSliderCard: React.FC<CardSliderCardProps> = ({ content, iconPack, corewellStyleOverrides }: CardSliderCardProps) => {

  const corewellTypographyOverrides = corewellStyleOverrides ? `${corewellCardGridOverrideClasses?.cardCaptionTypography}` : '';
  const descriptionClasses = `card-slider-description body-small ${corewellTypographyOverrides}`;

  return (
    <div className="card-slider-card">
      <ShLink className="card-link" iconPack={iconPack} reference={content?.card_slider_card_link}>
        <div className="card-slider-card-image">
          <GatsbyImage
            className="image"
            image={content?.image?.file?.localAsset?.childImageSharp?.gatsbyImageData}
            alt={content?.image?.alt_text}
          />
        </div>
        <div className="card-slider-card-body">
          <h6 className="card-slider-card-subhead">{content?.content_headline}</h6>
          <div className={descriptionClasses}>{content?.description}</div>
        </div>
      </ShLink>
    </div>
  );
};

export default CardSliderCard;
